/**
 * 将接口/模拟数据中的 i18n key 转为当前语言文案。
 * - 若 raw 形如 `a.b.c` 且存在对应翻译，则返回翻译
 * - 否则原样返回（兼容真实后端中文/英文文案）
 */
export function localizeText(
  raw: string | null | undefined,
  t: (key: string) => string
): string {
  if (raw == null || raw === '') return '';
  // 避免把普通句子当 key（含空格、中文等）
  if (!/^[a-zA-Z][a-zA-Z0-9_.-]*$/.test(raw)) return raw;
  if (!raw.includes('.')) return raw;
  const translated = t(raw);
  return translated === raw ? raw : translated;
}

const LEGACY_BRAND_RE = /Workerspace|Worker\s*Space|workerspace/gi;

/** 旧品牌名统一替换为 PANTA MARKET */
export function replaceLegacyBrand(text: string): string {
  return String(text || '').replace(LEGACY_BRAND_RE, 'PANTA MARKET');
}

function hasLegacyBrand(text: string): boolean {
  return /Workerspace|Worker\s*Space|workerspace/i.test(text);
}

/**
 * 服务条款 / 隐私政策等内容：
 * - 支持 i18n key
 * - 后端若仍返回 Workerspace，改写或回退到本地文案
 */
export function resolveBrandedLegalText(
  raw: string | null | undefined,
  localeFallbackKey: string,
  t: (key: string) => string
): string {
  const localized = localizeText(raw, t);
  if (!localized || hasLegacyBrand(localized)) {
    const fallback = t(localeFallbackKey);
    if (fallback && fallback !== localeFallbackKey) {
      return replaceLegacyBrand(fallback);
    }
  }
  return replaceLegacyBrand(localized || t(localeFallbackKey));
}
